'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    msg_captcha: 'Você deve marcar o captcha para continuar!',
  },
  en: {
    msg_captcha: 'You must check the captcha to continue!',
  },
  es: {
    msg_captcha: '¡Debes verificar el captcha para continuar!',
  },
};

const appAccessCode = {
  settings: {
    $btnAccessCode: document.querySelectorAll('.js-access-code'),
    url: '/entrar/codigo-de-acesso',
  },

  bindActions() {
    /* Evento responsável pela requisição de geração de código de acesso por celular */
    let post = {};

    s.$btnAccessCode.forEach($el => {
      $el.addEventListener('click', e => {
        e.preventDefault();

        let v = grecaptcha.getResponse();

        if (v.length == 0) {
          Swal.fire('', tr[lang].msg_captcha, 'error');
        } else {
          post.email = document.querySelector('input[name="email"]').value;
          post._token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

          $.ajax({
            type: 'POST',
            url: s.url,
            data: post,
            dataType: 'json',
            success: function (data) {
              if (data.success) {
                document.getElementById('send-block').classList.remove('u-display--none');

                Swal.fire({
                  title: data.title,
                  text: data.message,
                  icon: 'success',
                });
              } else {
                Swal.fire({
                  title: data.title,
                  text: data.message,
                  icon: 'error',
                });
              }
            },
          });
        }
      });
    });
  },

  init() {
    _this.bindActions();
  },
};

const s = appAccessCode.settings,
  _this = appAccessCode;

export default _this;
